import { Divider } from '@vk-cloud-solutions/marketing-ui';
import { useRouter } from 'next/navigation';

import { ArticleCardProps } from '~components/ArticleCard/ArticleCard.types';
import { ArticleCardSmall } from '~components/ArticleCardSmall/ArticleCardSmall';
import { SectionEvent } from '~components/SectionEvent/SectionEvent';
import { useCategory } from '~hooks/useCategory';

import styles from './CategoryPageNews.module.scss';
import { CategoryPageNewsProps } from './CategoryPageNews.types';

export const CategoryPageNews = ({
  articles,
  sectionEvent,
  category,
}: CategoryPageNewsProps) => {
  const router = useRouter();
  const { setCategory } = useCategory();

  const handleArticleClick = (article: ArticleCardProps) => {
    setCategory(category);
    router.push(article.href);
  };

  return (
    <div className={styles.catalog}>
      {articles
        ?.slice(0, Math.ceil(articles.length / 2))
        .map((card) => (
          <ArticleCardSmall
            key={card.id}
            {...card}
            onClick={() => handleArticleClick(card)}
          />
        ))}

      {sectionEvent && (
        <SectionEvent {...sectionEvent} className={styles.event} />
      )}

      {!sectionEvent && <Divider className={styles.divider} />}

      {articles
        ?.slice(Math.ceil(articles.length / 2), articles.length)
        .map((card) => <ArticleCardSmall key={card.id} {...card} />)}
    </div>
  );
};
